import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'small-spinner',
    template: require('./small-spinner.template.html')
})
export class SmallSpinnerComponent {
    @Input() loader: boolean = false;
    constructor() {

    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/components/small-spinner.component.ts